import React from 'react';

import { H4, S } from 'components/typography';

import { useSectionCommands } from '../../commands/CustomizationCommandsContext';
import { useLabels } from '../../i18n/useLabels';
import type { TemplateCustomizationViewModel } from '../../viewmodels/createTemplateCustomizationViewModel';
import { SortableList } from '../dnd/SortableList';
import { SectionAccordion } from '../sections/SectionAccordion';

import styles from './QuestionsPanel.scss';

type Props = {
  viewModel: Pick<TemplateCustomizationViewModel, 'sections' | 'emptyMessage'>;
};

export function QuestionsPanel({ viewModel }: Props) {
  const labels = useLabels();
  const { reorder } = useSectionCommands();
  const { sections } = viewModel;

  return (
    <div className={styles.panel}>
      <H4>{labels.questionsHeading}</H4>
      <SortableList
        items={sections.map(section => ({
          id: section.id,
          name: section.name,
        }))}
        canReorder={sections.some(section => section.reorder.canReorder)}
        onReorder={reorder}
      >
        {sections.map(section => (
          <SectionAccordion key={section.id} viewModel={section} />
        ))}
      </SortableList>
      {viewModel.emptyMessage && (
        <S variant="secondary">
          {labels.formatMessage(viewModel.emptyMessage)}
        </S>
      )}
    </div>
  );
}
